import { gql } from "@apollo/client";

export const VALIDATE_PARTNER_API_KEY = gql`
  mutation ValidatePartnerApiKey($apiKey: String!) {
    validatePartnerApiKey(apiKey: $apiKey) {
      success
      message
      data
    }
  }
`;

// Auth APIs

export const GET_PUBLIC_PLATFORM_INFO = gql`
  query GetPublicPlatformInfo {
    getPublicPlatformInfo {
      success
      data
    }
  }
`;

export const SEND_USER_OTP = gql`
  mutation SendUserOtp($email: String!, $recaptchaToken: String) {
    sendUserOtp(data: { email: $email, recaptchaToken: $recaptchaToken }) {
      success
      message
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      success
      message
      data
    }
  }
`;

export const SEND_USER_LOGIN_OTP = gql`
  mutation LoginSendOtp($email: String!, $password: String!, $recaptchaToken: String) {
    loginSendOtp(data: { email: $email, password: $password, recaptchaToken: $recaptchaToken }) {
      success
      message
      data
    }
  }
`;

export const LOGIN_USER = gql`
  mutation LoginVerifyOtp($data: LoginVerifyOtpInput!) {
    loginVerifyOtp(data: $data) {
      success
      message
      data
    }
  }
`;

export const FIND_BEST_MERCHANT = gql`
  mutation FindBestMerchantForTransaction(
    $transactionType: String!
    $payAmount: Float!
    $payCurrency: String!
    $receiveAmount: Float!
    $receiveCurrency: String!
    $paymentMethod: String!
    $walletAddress: String!
    $referenceId: String!
    $status: String!
    $chainId: String
    $isStaging: Boolean

    # PAGINATION
    $page: Int
    $limit: Int
    $search: String
  ) {
    findBestMerchantForTransaction(
      data: {
        transactionType: $transactionType
        payAmount: $payAmount
        payCurrency: $payCurrency
        receiveAmount: $receiveAmount
        receiveCurrency: $receiveCurrency
        paymentMethod: $paymentMethod
        walletAddress: $walletAddress
        referenceId: $referenceId
        status: $status
        chainId: $chainId
        isStaging: $isStaging
      }

      pagination: {
        page: $page
        limit: $limit
        search: $search
      }
    ) {
      success
      message
      data
    }
  }
`;

export const GET_MERCHANT_OFFERS = gql`
  query GetMerchantOffers(
    $merchantId: Int!
    $cryptoCurrency: String!
    $fiatCurrency: String!
    $page: Int
    $limit: Int
  ) {
    getMerchantOffers(
      merchantId: $merchantId
      cryptoCurrency: $cryptoCurrency
      fiatCurrency: $fiatCurrency
      pagination: { page: $page, limit: $limit }
    ) {
      success
      message
      data
    }
  }
`;

export const CREATE_TRANSACTION = gql`
  mutation CreateTransaction($data: CreateTransactionInput!) {
    createTransaction(data: $data) {
      success
      message
      data
    }
  }
`;

export const UPDATE_TRANSACTION = gql`
  mutation UpdateTransaction(
    $transactionId: Int!
    $data: UpdateTransactionInput!
  ) {
    updateTransaction(
      transactionId: $transactionId
      data: $data
    ) {
      success
      message
      data
    }
  }
`;

export const GET_USER_TRANSACTIONS = gql`
  query GetUserTransactions($pagination: PaginationInput) {
    getUserTransactions(pagination: $pagination) {
      success
      message
      data
    }
  }
`;

export const CONFIRM_ESCROW_RELEASE = gql`
  mutation ConfirmEscrowRelease(
    $deallogId: String!
    $status: String!
  ) {
    confirmEscrowRelease(
      deallogId: $deallogId
      status: $status
    ) {
      success
      message
    }
  }
`;

export const GET_USER_PROFILE = gql`
  query GetUserProfile {
    getUserProfile {
      success
      message
      data
    }
  }
`;

export const GET_TRANSACTION_BY_ID = gql`
  query GetTransactionById($transactionId: Int!) {
  getTransactionById(
    transactionId: $transactionId
  ) {
    success
    message
    data
  }
}
`;

export const GET_USER_KYC_LIMITS = gql`
  query GetUserKycAndLimits {
    getUserKycAndLimits {
      success
      message
      data
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile($data: UpdateUserDto!) {
    updateUserProfile(data: $data) {
      success
      message
      data
    }
  }
`;

export const SOCIAL_LOGIN_USER = gql`
  mutation SocialLoginUser($data: SocialLoginInput!) {
    socialLoginUser(data: $data) {
      success
      message
      data
    }
  }
`;

export const GET_MY_LIMITS = gql`
  query getMyLimits {
    getMyLimits {
      success
      message
      data
    }
  }
`;

export const GET_GLOBAL_PAYMENT_METHODS = gql`
  query {
    getAllGlobalPaymentMethods {
      success
      data
    }
  }
`;

export const GET_ACTIVE_CURRENCIES = gql`
  query {
    getActiveCurrencies {
      success
      data
    }
  }
`;

// ─── Security ────────────────────────────────────────────────────────────────

export const GET_MY_LOGIN_HISTORY = gql`
  query GetMyLoginHistory($take: Float, $skip: Float) {
    getMyLoginHistory(take: $take, skip: $skip) {
      success
      message
      data
    }
  }
`;

export const GET_MY_SESSIONS = gql`
  query GetMySessions($take: Float, $skip: Float) {
    getMySessions(take: $take, skip: $skip) {
      success
      message
      data
    }
  }
`;

export const LOGOUT = gql`
  mutation Logout {
    logout {
      success
      message
    }
  }
`;

export const REVOKE_SESSION = gql`
  mutation RevokeSession($sessionId: String!) {
    revokeSession(sessionId: $sessionId) {
      success
      message
    }
  }
`;

export const REVOKE_ALL_SESSIONS = gql`
  mutation RevokeAllSessions {
    revokeAllSessions {
      success
      message
    }
  }
`;

export const SET_ANTI_PHISHING_CODE = gql`
  mutation SetAntiPhishingCode($code: String!) {
    setAntiPhishingCode(code: $code) {
      success
      message
    }
  }
`;

export const GET_ANTI_PHISHING_CODE = gql`
  query GetAntiPhishingCode {
    getAntiPhishingCode {
      success
      message
      data
    }
  }
`;

// ─── Two-Factor Authentication (Email / Authenticator app choice) ───────

export const GET_TWO_FACTOR_STATUS = gql`
  query GetTwoFactorStatus {
    getTwoFactorStatus {
      success
      message
      data
    }
  }
`;

export const START_2FA_SETUP = gql`
  mutation Start2FASetup {
    start2FASetup {
      success
      message
      data
    }
  }
`;

export const CONFIRM_2FA_SETUP = gql`
  mutation Confirm2FASetup($secret: String!, $code: String!) {
    confirm2FASetup(secret: $secret, code: $code) {
      success
      message
    }
  }
`;

export const SWITCH_TWO_FACTOR_METHOD = gql`
  mutation SwitchTwoFactorMethod {
    switchTwoFactorMethod {
      success
      message
    }
  }
`;

export const SEND_ACTION_OTP = gql`
  mutation SendActionOtp($action: String!) {
    sendActionOtp(action: $action) {
      success
      message
    }
  }
`;

export const VERIFY_ACTION_OTP = gql`
  mutation VerifyActionOtp($action: String!, $otp: String!) {
    verifyActionOtp(action: $action, otp: $otp) {
      success
      message
    }
  }
`;

